import { render, staticRenderFns } from "./editStudentRoute.vue?vue&type=template&id=4ff43728"
import script from "./editStudentRoute.vue?vue&type=script&lang=js"
export * from "./editStudentRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports